import store from "@store";
import liff from "@line/liff";
import Vue from 'vue'

export default function lineGetProfileAndLogin({
  liffId,
  redirectFrom,
  next,
  callBack,
  callBackBind,
  callBackError,
  redirectUri = window.location.href
} = {}) {
  liff.getProfile()
    .then((response) => {
      tryToLineLogIn({
        liffId,
        liffUserId: response.userId,
        redirectFrom,
        next,
        callBack,
        callBackBind,
        callBackError
      });
    })
    .catch((error) => {
      if(error.message === 'The access token revoked') {
        liff.logout();
        liff.login({ redirectUri })
      } else {
        alert(`發生錯誤：${error.message}\n系統將重新導向到首頁⋯⋯`);

        if(callBackError) {
          callBackError();
        } else {
          next({
            name: 'home',
            replace: true
          })
        }
      }
    })
};

function tryToLineLogIn({ liffId, liffUserId, redirectFrom, next, callBack, callBackBind, callBackError } = {}) {
  store.dispatch('auth/lineLogIn', {
    lineId: liffUserId
  })
    .then((response) => {
      tryToSetCurrentLiffId({ liffId })
        .then(() => {
          const shouldOpenDialogLineNotify = () => {
            const isBound = response.lineInfo.isBindLineNotify
            const invisibleDialog = store.state.auth.currentInvisibleDialogLineNotify
            return !isBound && !invisibleDialog
          }

          if(redirectFrom) {
            if (shouldOpenDialogLineNotify()) {
              const url = new URL(redirectFrom)
              url.searchParams.set('dialogDialogLineNotifyVisible', true)
              location.replace(url)
            } else {
              location.replace(redirectFrom);
            }
          }

          if(callBack) {
            callBack()
            if (shouldOpenDialogLineNotify())
              Vue.options.methods.$globalDialog('DialogLineNotify')
          }
        });
    })
    .catch((error) => {
      if(error.status === 'MERCHANT_MEMBER_FRONT_MEMBER_NOT_FOUND') {
        if(callBackBind) {
          callBackBind({ liffUserId });
        } else {
          next({
            name: store.getters['auth/isLoggedIn']
              ? 'logout'
              : 'login',
            query: {
              redirectFrom,
              liffUserId,
            },
            replace: true
          })
        }
      } else {
        alert(`發生錯誤：${error.message}\n系統將重新導向到首頁⋯⋯`);

        if(callBackError) {
          callBackError();
        } else {
          next({
            name: 'home',
            replace: true
          })
        }
      }
    })
}

async function tryToSetCurrentLiffId({ liffId } = {}) {
  await store.dispatch('auth/setCurrentLiffId', liffId)
    .then(() => {
      return true
    })
}
